
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as homeVs6hy5w8j5mRSaDBEhaRy8t_V7_sw08bwnyIB8UfcXIMeta } from "/home/circleci/project/pages/home.vue?macro=true";
import { default as planyQ7Dd43FkI1DtxIdXt3zJYeXjOi_aT0OXJoucLuScl8Meta } from "/home/circleci/project/pages/plan.vue?macro=true";
import { default as indexgPMh34d7GGlJjWWQ_45ttWxTIVbc26EhZ5MEtr5BoKFQUMeta } from "/home/circleci/project/pages/index.vue?macro=true";
import { default as loginRN_3lK7gF1HRoQoirXtLtHNJQgJv_f5KYrOpRK2EdYUMeta } from "/home/circleci/project/pages/login.vue?macro=true";
import { default as emailoOSO5mIplp__XUex9vq_MPDNoMi3Qetzqmp2e9MMHPQMeta } from "/home/circleci/project/pages/account/email.vue?macro=true";
import { default as indexu7XJrYHuSviSFTOehHgkIwKWGe7qBGUgji8UEyRmh1IMeta } from "/home/circleci/project/pages/account/index.vue?macro=true";
import { default as passwordqbysPVt7_63ZVTO4uda0FL9RP7aZa2ccxTmzTdTD7SIMeta } from "/home/circleci/project/pages/account/password.vue?macro=true";
import { default as notificationu5ITqZKotP2G3mCm08lb6w01oi7OQ5_45qtjlprAxLfiMMeta } from "/home/circleci/project/pages/account/notification.vue?macro=true";
import { default as accountJNC3G5e2va_4to17_45imMd5o_9fLVmSYtnhscfcFhPEUMeta } from "/home/circleci/project/pages/account.vue?macro=true";
import { default as indexSO_UTVnkOjtjN_12IkG1Oz2_vZgnovSXEHTvYEy604YMeta } from "/home/circleci/project/pages/messages/index.vue?macro=true";
import { default as indexAw1HSURqrg7kFDHYZ_45HbQLWazIFjH8K4cmuhr4XgRJoMeta } from "/home/circleci/project/pages/messages/[userDisplayId]/index.vue?macro=true";
import { default as detailwnfAkzinImpPTN5l4EacQxF54Ry9td6MCrH_45800BH7IMeta } from "/home/circleci/project/pages/messages/[userDisplayId]/detail.vue?macro=true";
import { default as _91userDisplayId_93U_451WmcpO4gN6X8FjnEXXmINstKvE42NYH8kHmJA2bCcMeta } from "/home/circleci/project/pages/messages/[userDisplayId].vue?macro=true";
import { default as messagesOy8vln1ggoB1ZQYRjKi_Kb_ed1KY8TnXwCwoTGoj33kMeta } from "/home/circleci/project/pages/messages.vue?macro=true";
import { default as indexvJeBulkOPO2ARtjuzPJQCZHP6VyAltLTtpBwjVqANr4Meta } from "/home/circleci/project/pages/jobs/index.vue?macro=true";
import { default as print7YizGzQqHr8vmmQU9aJCT_YKdM4tvkkjJAxP_5gwkucMeta } from "/home/circleci/project/pages/debug/print.vue?macro=true";
import { default as createnUNaQdIc_93CuQpHpC5M_IGT_45mc436HEu0E_45_45KuyKy4Meta } from "/home/circleci/project/pages/jobs/create.vue?macro=true";
import { default as indexUOapnBXsplJXOA_45Uq7Ad6a_ksA3SlESavvJtjZGacC4Meta } from "/home/circleci/project/pages/roles/index.vue?macro=true";
import { default as cookie07ajp7ThtJbZBECYbUJ1IAc7Q9Ku1zhS2ebalbxyxFIMeta } from "/home/circleci/project/pages/debug/cookie.vue?macro=true";
import { default as archivexYl_45RvxDOI3b1WQQEbzaW_kluzZnWRXf5Z7IttQxsOUMeta } from "/home/circleci/project/pages/jobs/archive.vue?macro=true";
import { default as _91code_93VmkGRYukyHX_45blpjTuOOc6uv5D6F_sojfPBA5PEue48Meta } from "/home/circleci/project/pages/roles/[code].vue?macro=true";
import { default as index0E4FtzhI0s_Heeg9Ve5JErX4f0QPa1t7t9DA29PSRgMMeta } from "/home/circleci/project/pages/scout/search/index.vue?macro=true";
import { default as _91userDisplayId_93AeA_RPr4PORsw86amrGmdXKXAZInXN_i8vJoYKZQ6ZAMeta } from "/home/circleci/project/pages/scout/search/users/[userDisplayId].vue?macro=true";
import { default as searchiFfqphCbAH8V3aJsVCYRswIV948L6M3_uQGpgl6YdOAMeta } from "/home/circleci/project/pages/scout/search.vue?macro=true";
import { default as indexFcNBKX2T20ZSAD_XJ7KtZvChJgVjEeGrX3r3DmiwK7sMeta } from "/home/circleci/project/pages/company/index.vue?macro=true";
import { default as indexAkHdtyQ2_2_45p9yyVKHH3S81ZIQ1h7sLSmhNGMlN8z0MMeta } from "/home/circleci/project/pages/operation-log/index.vue?macro=true";
import { default as memberoPL9e4Tb9e_45R8jV3gYhUWbQVwH8YmMUwnf8X9wBksTwMeta } from "/home/circleci/project/pages/operation-log/member.vue?macro=true";
import { default as redesignerbNI_45htyWetTU_TTcLv4SfKCl9KXsG66B1du3Q45V9UYMeta } from "/home/circleci/project/pages/operation-log/redesigner.vue?macro=true";
import { default as operation_45logleKcgmCuFjMT_459fVBIdh0eirl6r3aDusniXAK_45BnYWAMeta } from "/home/circleci/project/pages/operation-log.vue?macro=true";
import { default as optional_45menudXCdzeSRGcooOJCC0stJObAfvpFR1lCLKbaPnloW_vwMeta } from "/home/circleci/project/pages/optional-menu.vue?macro=true";
import { default as password_45resetUbogEmF_45INOvNgR75jZ2SSYdq9iX6rH4kDIxKzYBOqMMeta } from "/home/circleci/project/pages/password-reset.vue?macro=true";
import { default as indexeIktaHI9JQMLY_45bHJNFsmLMOlys2Jg_C88NaTjkrpyUMeta } from "/home/circleci/project/pages/companies/index.vue?macro=true";
import { default as account_45registerbMZHgoUjnKXpj3_zz6oUeYFYlyg_mC0_45kSXkbNHaJgQMeta } from "/home/circleci/project/pages/account-register.vue?macro=true";
import { default as createVW_f4jGqE21XLkq0bPgdNeXayLaEEZyUd_noZ5PahZEMeta } from "/home/circleci/project/pages/companies/create.vue?macro=true";
import { default as indexgNVb10uqA6jUB3nlEjZjBet3b3nx8DAojJ9BlF4ivoAMeta } from "/home/circleci/project/pages/company-settings/index.vue?macro=true";
import { default as membersf7gHcLD5C10guAhUcqWzkymU62sGzcGPTWbuX1Nmq20Meta } from "/home/circleci/project/pages/company-settings/members.vue?macro=true";
import { default as notificationxXro76F0KcRk2MBNPK7osOBhUeh4NzNV0W4EKWi5XnIMeta } from "/home/circleci/project/pages/company-settings/notification.vue?macro=true";
import { default as company_45settingsUyBiAZQZIzJ_f4Bd6V2RkEWmp0asJxQVhxbwqOPADDsMeta } from "/home/circleci/project/pages/company-settings.vue?macro=true";
import { default as job_45statusC3uSKCmOrfq6F9LaWOGYl9DRtr3sl6L5Sdd_oFAJTAYMeta } from "/home/circleci/project/pages/debug/job-status.vue?macro=true";
import { default as permissionq06iIE4aFuP6AMaAFnCTE0xhNysVxr84W1OP_45PNp12EMeta } from "/home/circleci/project/pages/debug/permission.vue?macro=true";
import { default as popup_45menu_45s7r4FxnosnRDJ1VaKR8DoWu6YqHpf14Xmtg5_45fQGy4Meta } from "/home/circleci/project/pages/debug/popup-menu.vue?macro=true";
import { default as trial_45formaa4_45D0EGizEEZ42_45lhqb37AbVIekgcGsD0BeoWC2ugkMeta } from "/home/circleci/project/pages/debug/trial-form.vue?macro=true";
import { default as _91userDisplayId_93FCgWpJ60cbbIamTPJ8nFvHbv_45rwy73orFpS9_8iCG3YMeta } from "/home/circleci/project/pages/interested-users/[userDisplayId].vue?macro=true";
import { default as interested_45usersVYsU9n4s315LOCFTQLVh0xbnbunRDFkdo1jiiKAhFe8Meta } from "/home/circleci/project/pages/interested-users.vue?macro=true";
import { default as archivevVB86_45kl7nqDIFav3wgBZbuZRQfbWWpt9LpsN3CiBEwMeta } from "/home/circleci/project/pages/companies/archive.vue?macro=true";
import { default as base_45selectD_459pRn_HOUBxKTcXShxTX2OEfY_45wLWx2X1ovo51BzbAMeta } from "/home/circleci/project/pages/debug/base-select.vue?macro=true";
import { default as employee_45accountsWuKZ0HFjYJ_45EJyIhNXn1_45BbPZcFkmvYRJvLGIuHBRoAMeta } from "/home/circleci/project/pages/employee-accounts.vue?macro=true";
import { default as indextVtRZe8KTN5ElMwhbd14lV9lu1rgC5p38PisbvzZnowMeta } from "/home/circleci/project/pages/job-samples/index.vue?macro=true";
import { default as indexJ52_adDBlJX8_45Lrcs9bI9vNsMquVVVVEMtzQpSgfFxUMeta } from "/home/circleci/project/pages/jobs/[code]/index.vue?macro=true";
import { default as index5AoXKYqWWCVt1KDN5k4PCRd6nTK1DXEAb2A_hJav4ZQMeta } from "/home/circleci/project/pages/talent-pool/index.vue?macro=true";
import { default as use_45sortableyOPEr1Ur_4569Eav6gGMdBMSZPWTOYZqXTBr_WO9M15eUMeta } from "/home/circleci/project/pages/debug/use-sortable.vue?macro=true";
import { default as indexWyXqUtM_45MnL5yHagaHiK3opHvrcV_45qOZwCL_gm8YtlQMeta } from "/home/circleci/project/pages/selection/progress/index.vue?macro=true";
import { default as _91userDisplayId_93exUiAfF6XJr8U6U1fbj66wnLbwrvtJv1PFh19XYP2QQMeta } from "/home/circleci/project/pages/selection/progress/users/[userDisplayId].vue?macro=true";
import { default as progressMZXFS88FXGrTa3hUD6wOMTYZ2xASqr_454Nn_45_JY_KwZ0Meta } from "/home/circleci/project/pages/selection/progress.vue?macro=true";
import { default as indexSPLg2NfbcRRnYaIy_f3TL2JmyU7vr6YvVJZKiei6f08Meta } from "/home/circleci/project/pages/job-campaigns/index.vue?macro=true";
import { default as cascade_45select6hAxfjfCBMNTpCNt0Zrd2HTxjfKgkVIhUue7wbuLxa0Meta } from "/home/circleci/project/pages/debug/cascade-select.vue?macro=true";
import { default as index24Ztt6JIxkrmo_YPAKHYXbXF9AywtZRAv2ZaNtGMIm0Meta } from "/home/circleci/project/pages/debug/messages/index.vue?macro=true";
import { default as indexuXtPK1Lp7K0oJr492rJTuTmQ8_45jytrokwTXR1LlGpLcMeta } from "/home/circleci/project/pages/generated-jobs/index.vue?macro=true";
import { default as createF5HkEIBGwMGGfXkYkz_45nirm8ybU0dog7yJZozMa1b80Meta } from "/home/circleci/project/pages/job-campaigns/create.vue?macro=true";
import { default as _91userDisplayId_93xwLMSahcWIXNKtXs8IsVPrD7__sKUiNVVUWXOKBtjtwMeta } from "/home/circleci/project/pages/assist/company-alumni/[userDisplayId].vue?macro=true";
import { default as company_45alumnip8qampBnu4vUDbbR5VbfWstXAPs_45Ic4YW78Bp8_Ty9MMeta } from "/home/circleci/project/pages/assist/company-alumni.vue?macro=true";
import { default as indexXhJ68RhzOrz_sC1vKrIwrTGeHEPQYBzXgTnMa9j6N5gMeta } from "/home/circleci/project/pages/companies/[code]/edit/index.vue?macro=true";
import { default as addition_hv8kNAgPWsheUZCYG5kW1xVeIz8QGaf5g7aKD_zhb8Meta } from "/home/circleci/project/pages/companies/[code]/edit/addition.vue?macro=true";
import { default as edita6MbPPxBNsSOWq13mLqybX0xHghvjp4t0xZQ65_DRV0Meta } from "/home/circleci/project/pages/companies/[code]/edit.vue?macro=true";
import { default as _91code_93h5BR_45X0ojkg5sqOVV1t0FspAzODNhmiMNirABHqC6mAMeta } from "/home/circleci/project/pages/debug/messages/[code].vue?macro=true";
import { default as headeryKwEwMkFv9LAbGZ6_CwmIa7fe_w44y9hdx7TsyLv3i4Meta } from "/home/circleci/project/pages/debug/messages/header.vue?macro=true";
import { default as _91userDisplayId_93OFvLxingxWSApsjBNOmI_45DEI0Y_45HCC9K0p3UpaaQYeMMeta } from "/home/circleci/project/pages/updated-users/profile/[userDisplayId].vue?macro=true";
import { default as profileTWXNBdvn3AOtszdlNbDVd5HZlSrWt4XXwU34Ac6Q69cMeta } from "/home/circleci/project/pages/updated-users/profile.vue?macro=true";
import { default as indexPP2ou8oy0t7gTPimzm2ZAo5FgXhVwB7LpCzayRy2jKkMeta } from "/home/circleci/project/pages/companies/[code]/index.vue?macro=true";
import { default as indexNW2EJG1motPFljkecj3RYh5lTYD8ZRD_45pf7jx_45LXNT4Meta } from "/home/circleci/project/pages/company-accounts/index.vue?macro=true";
import { default as indexDOCM_dL_458iAR41aLbBgW12eY9VHZ8jJBeSonBEmgbx8Meta } from "/home/circleci/project/pages/jobs/[code]/edit/index.vue?macro=true";
import { default as indexJyLgYE9Bj56aVmPv73K8_45SomFJvKqLoKjIPfOc18E2MMeta } from "/home/circleci/project/pages/talent-pool/[listCode]/index.vue?macro=true";
import { default as _91userDisplayId_93WDjlJmF_45SG8xJzoYzJOTrGo4TxVxCRbFQC_dJec1eYoMeta } from "/home/circleci/project/pages/talent-pool/[listCode]/users/[userDisplayId].vue?macro=true";
import { default as _91listCode_9399aryceEe2Gcp_nQf1FYeMj_D_2HTmtUV8wFytT2ggkMeta } from "/home/circleci/project/pages/talent-pool/[listCode].vue?macro=true";
import { default as _91userDisplayId_93nD8K3MJxm6iaah4twXsQIzI13IOIW_45pbcnnlfx22S3oMeta } from "/home/circleci/project/pages/updated-users/intention/[userDisplayId].vue?macro=true";
import { default as intention1c_xL3xcRuVBhp_45vo7mr1asPmoJIWmygEx_45zuvaLlUEMeta } from "/home/circleci/project/pages/updated-users/intention.vue?macro=true";
import { default as previewGoJnhi26CW0Yvi9uGIppL9WxkTRiC2dLNW4JJRK_SroMeta } from "/home/circleci/project/pages/jobs/[code]/edit/preview.vue?macro=true";
import { default as addition8pRFI5mWGIdYgK9tF_1gdje6JtFvtSHBcPrhPowngHgMeta } from "/home/circleci/project/pages/companies/[code]/addition.vue?macro=true";
import { default as editZj1NNtdLe3DofNmm8w1sXsCdxS9QT8q0dyguRXeyk5MMeta } from "/home/circleci/project/pages/job-campaigns/[code]/edit.vue?macro=true";
import { default as additiong70SAMnkn_45c1wQU1CM8xCr9yp5u_vdlcxNNiqG_45aewQMeta } from "/home/circleci/project/pages/jobs/[code]/edit/addition.vue?macro=true";
import { default as indexCyh_45cs2D_RcejN00UaX4EIYKGDFoOUi6rU7t5RP9yRMMeta } from "/home/circleci/project/pages/jobs/[code]/preview/index.vue?macro=true";
import { default as _91token_935LzBOlekUwIP2kl2d9gv9f2SIkk_45md9faczKpG5GHbUMeta } from "/home/circleci/project/pages/mail-token/[type]/[token].vue?macro=true";
import { default as indexKJP5ph0Py_45OrsQlRjgvuCFYwMwWLwAijLEJigdryVK4Meta } from "/home/circleci/project/pages/jobs/[code]/duplicate/index.vue?macro=true";
import { default as printtK7OiSbz3d16jloGmsGjZ2xFk9qyzoMGLJnJc48kLUIMeta } from "/home/circleci/project/pages/users/[userDisplayId]/print.vue?macro=true";
import { default as card_45user_45detailxdSKbMczX6VrlaOsrv7lXZMyRkZ5utR7sADsQGcSXH4Meta } from "/home/circleci/project/pages/debug/scout/card-user-detail.vue?macro=true";
import { default as index0QiQ26fHmL_2_454cbUvoIEEi8_9mcUuapRwvWUX4wnBwMeta } from "/home/circleci/project/pages/design-challenges-2026/index.vue?macro=true";
import { default as indexl9wj4mgJwj7qke9HN2yYotl69hcTwbuXIDPbXmDisMUMeta } from "/home/circleci/project/pages/generated-jobs/[code]/edit/index.vue?macro=true";
import { default as _91userDisplayId_93Bl4F8Os9fORogGohii0hpheBZguGid1YU3AOPCXcynMMeta } from "/home/circleci/project/pages/job-introduction/[userDisplayId].vue?macro=true";
import { default as previewfNlscIXvttguRDPGQlp5keiHFqLxgYhjCaMLjjijsbwMeta } from "/home/circleci/project/pages/generated-jobs/[code]/edit/preview.vue?macro=true";
import { default as index0KCGAh4R_45seJUcWft4lcTg6Vtd2piyRW4kHVHSAhYfkMeta } from "/home/circleci/project/pages/generated-jobs/[code]/preview/index.vue?macro=true";
import { default as _91displayId_93HGnL9IBN2codlD8phsZzsmj_50j9_45HDdRbgoVlwfxLIMeta } from "/home/circleci/project/pages/design-challenges-2026/[assignmentCode]/[displayId].vue?macro=true";
export default [
  {
    name: "home",
    path: "/home",
    meta: homeVs6hy5w8j5mRSaDBEhaRy8t_V7_sw08bwnyIB8UfcXIMeta || {},
    component: () => import("/home/circleci/project/pages/home.vue")
  },
  {
    name: "plan",
    path: "/plan",
    meta: planyQ7Dd43FkI1DtxIdXt3zJYeXjOi_aT0OXJoucLuScl8Meta || {},
    component: () => import("/home/circleci/project/pages/plan.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexgPMh34d7GGlJjWWQ_45ttWxTIVbc26EhZ5MEtr5BoKFQUMeta || {},
    component: () => import("/home/circleci/project/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginRN_3lK7gF1HRoQoirXtLtHNJQgJv_f5KYrOpRK2EdYUMeta || {},
    component: () => import("/home/circleci/project/pages/login.vue")
  },
  {
    name: accountJNC3G5e2va_4to17_45imMd5o_9fLVmSYtnhscfcFhPEUMeta?.name,
    path: "/account",
    meta: accountJNC3G5e2va_4to17_45imMd5o_9fLVmSYtnhscfcFhPEUMeta || {},
    component: () => import("/home/circleci/project/pages/account.vue"),
    children: [
  {
    name: "account-email",
    path: "email",
    meta: emailoOSO5mIplp__XUex9vq_MPDNoMi3Qetzqmp2e9MMHPQMeta || {},
    component: () => import("/home/circleci/project/pages/account/email.vue")
  },
  {
    name: "account",
    path: "",
    meta: indexu7XJrYHuSviSFTOehHgkIwKWGe7qBGUgji8UEyRmh1IMeta || {},
    component: () => import("/home/circleci/project/pages/account/index.vue")
  },
  {
    name: "account-password",
    path: "password",
    meta: passwordqbysPVt7_63ZVTO4uda0FL9RP7aZa2ccxTmzTdTD7SIMeta || {},
    component: () => import("/home/circleci/project/pages/account/password.vue")
  },
  {
    name: "account-notification",
    path: "notification",
    meta: notificationu5ITqZKotP2G3mCm08lb6w01oi7OQ5_45qtjlprAxLfiMMeta || {},
    component: () => import("/home/circleci/project/pages/account/notification.vue")
  }
]
  },
  {
    name: messagesOy8vln1ggoB1ZQYRjKi_Kb_ed1KY8TnXwCwoTGoj33kMeta?.name,
    path: "/messages",
    meta: messagesOy8vln1ggoB1ZQYRjKi_Kb_ed1KY8TnXwCwoTGoj33kMeta || {},
    component: () => import("/home/circleci/project/pages/messages.vue"),
    children: [
  {
    name: "message-list",
    path: "",
    meta: indexSO_UTVnkOjtjN_12IkG1Oz2_vZgnovSXEHTvYEy604YMeta || {},
    component: () => import("/home/circleci/project/pages/messages/index.vue")
  },
  {
    name: _91userDisplayId_93U_451WmcpO4gN6X8FjnEXXmINstKvE42NYH8kHmJA2bCcMeta?.name,
    path: ":userDisplayId()",
    meta: _91userDisplayId_93U_451WmcpO4gN6X8FjnEXXmINstKvE42NYH8kHmJA2bCcMeta || {},
    component: () => import("/home/circleci/project/pages/messages/[userDisplayId].vue"),
    children: [
  {
    name: "messages-user",
    path: "",
    meta: indexAw1HSURqrg7kFDHYZ_45HbQLWazIFjH8K4cmuhr4XgRJoMeta || {},
    component: () => import("/home/circleci/project/pages/messages/[userDisplayId]/index.vue")
  },
  {
    name: "messages-user-detail",
    path: "detail",
    meta: detailwnfAkzinImpPTN5l4EacQxF54Ry9td6MCrH_45800BH7IMeta || {},
    component: () => import("/home/circleci/project/pages/messages/[userDisplayId]/detail.vue")
  }
]
  }
]
  },
  {
    name: "JobList",
    path: "/jobs",
    meta: indexvJeBulkOPO2ARtjuzPJQCZHP6VyAltLTtpBwjVqANr4Meta || {},
    component: () => import("/home/circleci/project/pages/jobs/index.vue")
  },
  {
    name: "debug-print",
    path: "/debug/print",
    component: () => import("/home/circleci/project/pages/debug/print.vue")
  },
  {
    name: "jobs-create",
    path: "/jobs/create",
    meta: createnUNaQdIc_93CuQpHpC5M_IGT_45mc436HEu0E_45_45KuyKy4Meta || {},
    component: () => import("/home/circleci/project/pages/jobs/create.vue")
  },
  {
    name: "roles",
    path: "/roles",
    meta: indexUOapnBXsplJXOA_45Uq7Ad6a_ksA3SlESavvJtjZGacC4Meta || {},
    component: () => import("/home/circleci/project/pages/roles/index.vue")
  },
  {
    name: "debug-cookie",
    path: "/debug/cookie",
    component: () => import("/home/circleci/project/pages/debug/cookie.vue")
  },
  {
    name: "jobs-archive",
    path: "/jobs/archive",
    meta: archivexYl_45RvxDOI3b1WQQEbzaW_kluzZnWRXf5Z7IttQxsOUMeta || {},
    component: () => import("/home/circleci/project/pages/jobs/archive.vue")
  },
  {
    name: "roles-code",
    path: "/roles/:code()",
    meta: _91code_93VmkGRYukyHX_45blpjTuOOc6uv5D6F_sojfPBA5PEue48Meta || {},
    component: () => import("/home/circleci/project/pages/roles/[code].vue")
  },
  {
    name: searchiFfqphCbAH8V3aJsVCYRswIV948L6M3_uQGpgl6YdOAMeta?.name,
    path: "/scout/search",
    meta: searchiFfqphCbAH8V3aJsVCYRswIV948L6M3_uQGpgl6YdOAMeta || {},
    component: () => import("/home/circleci/project/pages/scout/search.vue"),
    children: [
  {
    name: "scout-search",
    path: "",
    meta: index0E4FtzhI0s_Heeg9Ve5JErX4f0QPa1t7t9DA29PSRgMMeta || {},
    component: () => import("/home/circleci/project/pages/scout/search/index.vue")
  },
  {
    name: "scout-search-user-detail",
    path: "users/:userDisplayId()",
    meta: _91userDisplayId_93AeA_RPr4PORsw86amrGmdXKXAZInXN_i8vJoYKZQ6ZAMeta || {},
    component: () => import("/home/circleci/project/pages/scout/search/users/[userDisplayId].vue")
  }
]
  },
  {
    name: "company",
    path: "/company",
    meta: indexFcNBKX2T20ZSAD_XJ7KtZvChJgVjEeGrX3r3DmiwK7sMeta || {},
    component: () => import("/home/circleci/project/pages/company/index.vue")
  },
  {
    name: operation_45logleKcgmCuFjMT_459fVBIdh0eirl6r3aDusniXAK_45BnYWAMeta?.name,
    path: "/operation-log",
    meta: operation_45logleKcgmCuFjMT_459fVBIdh0eirl6r3aDusniXAK_45BnYWAMeta || {},
    component: () => import("/home/circleci/project/pages/operation-log.vue"),
    children: [
  {
    name: "operation-log",
    path: "",
    meta: indexAkHdtyQ2_2_45p9yyVKHH3S81ZIQ1h7sLSmhNGMlN8z0MMeta || {},
    component: () => import("/home/circleci/project/pages/operation-log/index.vue")
  },
  {
    name: "operation-log-member",
    path: "member",
    meta: memberoPL9e4Tb9e_45R8jV3gYhUWbQVwH8YmMUwnf8X9wBksTwMeta || {},
    component: () => import("/home/circleci/project/pages/operation-log/member.vue")
  },
  {
    name: "operation-log-redesigner",
    path: "redesigner",
    meta: redesignerbNI_45htyWetTU_TTcLv4SfKCl9KXsG66B1du3Q45V9UYMeta || {},
    component: () => import("/home/circleci/project/pages/operation-log/redesigner.vue")
  }
]
  },
  {
    name: "optional-menu",
    path: "/optional-menu",
    meta: optional_45menudXCdzeSRGcooOJCC0stJObAfvpFR1lCLKbaPnloW_vwMeta || {},
    component: () => import("/home/circleci/project/pages/optional-menu.vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: password_45resetUbogEmF_45INOvNgR75jZ2SSYdq9iX6rH4kDIxKzYBOqMMeta || {},
    component: () => import("/home/circleci/project/pages/password-reset.vue")
  },
  {
    name: "companies",
    path: "/companies",
    meta: indexeIktaHI9JQMLY_45bHJNFsmLMOlys2Jg_C88NaTjkrpyUMeta || {},
    component: () => import("/home/circleci/project/pages/companies/index.vue")
  },
  {
    name: "account-register",
    path: "/account-register",
    meta: account_45registerbMZHgoUjnKXpj3_zz6oUeYFYlyg_mC0_45kSXkbNHaJgQMeta || {},
    component: () => import("/home/circleci/project/pages/account-register.vue")
  },
  {
    name: "companies-create",
    path: "/companies/create",
    meta: createVW_f4jGqE21XLkq0bPgdNeXayLaEEZyUd_noZ5PahZEMeta || {},
    component: () => import("/home/circleci/project/pages/companies/create.vue")
  },
  {
    name: company_45settingsUyBiAZQZIzJ_f4Bd6V2RkEWmp0asJxQVhxbwqOPADDsMeta?.name,
    path: "/company-settings",
    meta: company_45settingsUyBiAZQZIzJ_f4Bd6V2RkEWmp0asJxQVhxbwqOPADDsMeta || {},
    component: () => import("/home/circleci/project/pages/company-settings.vue"),
    children: [
  {
    name: "company-settings",
    path: "",
    meta: indexgNVb10uqA6jUB3nlEjZjBet3b3nx8DAojJ9BlF4ivoAMeta || {},
    component: () => import("/home/circleci/project/pages/company-settings/index.vue")
  },
  {
    name: "company-settings-members",
    path: "members",
    meta: membersf7gHcLD5C10guAhUcqWzkymU62sGzcGPTWbuX1Nmq20Meta || {},
    component: () => import("/home/circleci/project/pages/company-settings/members.vue")
  },
  {
    name: "company-settings-notification",
    path: "notification",
    meta: notificationxXro76F0KcRk2MBNPK7osOBhUeh4NzNV0W4EKWi5XnIMeta || {},
    component: () => import("/home/circleci/project/pages/company-settings/notification.vue")
  }
]
  },
  {
    name: "debug-job-status",
    path: "/debug/job-status",
    component: () => import("/home/circleci/project/pages/debug/job-status.vue")
  },
  {
    name: "debug-permission",
    path: "/debug/permission",
    component: () => import("/home/circleci/project/pages/debug/permission.vue")
  },
  {
    name: "debug-popup-menu",
    path: "/debug/popup-menu",
    component: () => import("/home/circleci/project/pages/debug/popup-menu.vue")
  },
  {
    name: "debug-trial-form",
    path: "/debug/trial-form",
    meta: trial_45formaa4_45D0EGizEEZ42_45lhqb37AbVIekgcGsD0BeoWC2ugkMeta || {},
    component: () => import("/home/circleci/project/pages/debug/trial-form.vue")
  },
  {
    name: "list-interested-users",
    path: "/interested-users",
    meta: interested_45usersVYsU9n4s315LOCFTQLVh0xbnbunRDFkdo1jiiKAhFe8Meta || {},
    component: () => import("/home/circleci/project/pages/interested-users.vue"),
    children: [
  {
    name: "interested-user-detail",
    path: ":userDisplayId()",
    meta: _91userDisplayId_93FCgWpJ60cbbIamTPJ8nFvHbv_45rwy73orFpS9_8iCG3YMeta || {},
    component: () => import("/home/circleci/project/pages/interested-users/[userDisplayId].vue")
  }
]
  },
  {
    name: "companies-archive",
    path: "/companies/archive",
    meta: archivevVB86_45kl7nqDIFav3wgBZbuZRQfbWWpt9LpsN3CiBEwMeta || {},
    component: () => import("/home/circleci/project/pages/companies/archive.vue")
  },
  {
    name: "debug-base-select",
    path: "/debug/base-select",
    meta: base_45selectD_459pRn_HOUBxKTcXShxTX2OEfY_45wLWx2X1ovo51BzbAMeta || {},
    component: () => import("/home/circleci/project/pages/debug/base-select.vue")
  },
  {
    name: "employee-accounts",
    path: "/employee-accounts",
    meta: employee_45accountsWuKZ0HFjYJ_45EJyIhNXn1_45BbPZcFkmvYRJvLGIuHBRoAMeta || {},
    component: () => import("/home/circleci/project/pages/employee-accounts.vue")
  },
  {
    name: "JobSamples",
    path: "/job-samples",
    meta: indextVtRZe8KTN5ElMwhbd14lV9lu1rgC5p38PisbvzZnowMeta || {},
    component: () => import("/home/circleci/project/pages/job-samples/index.vue")
  },
  {
    name: "jobs-code",
    path: "/jobs/:code()",
    meta: indexJ52_adDBlJX8_45Lrcs9bI9vNsMquVVVVEMtzQpSgfFxUMeta || {},
    component: () => import("/home/circleci/project/pages/jobs/[code]/index.vue")
  },
  {
    name: "talent-pool",
    path: "/talent-pool",
    meta: index5AoXKYqWWCVt1KDN5k4PCRd6nTK1DXEAb2A_hJav4ZQMeta || {},
    component: () => import("/home/circleci/project/pages/talent-pool/index.vue")
  },
  {
    name: "debug-use-sortable",
    path: "/debug/use-sortable",
    meta: use_45sortableyOPEr1Ur_4569Eav6gGMdBMSZPWTOYZqXTBr_WO9M15eUMeta || {},
    component: () => import("/home/circleci/project/pages/debug/use-sortable.vue")
  },
  {
    name: progressMZXFS88FXGrTa3hUD6wOMTYZ2xASqr_454Nn_45_JY_KwZ0Meta?.name,
    path: "/selection/progress",
    meta: progressMZXFS88FXGrTa3hUD6wOMTYZ2xASqr_454Nn_45_JY_KwZ0Meta || {},
    component: () => import("/home/circleci/project/pages/selection/progress.vue"),
    children: [
  {
    name: "selection-progress",
    path: "",
    meta: indexWyXqUtM_45MnL5yHagaHiK3opHvrcV_45qOZwCL_gm8YtlQMeta || {},
    component: () => import("/home/circleci/project/pages/selection/progress/index.vue")
  },
  {
    name: "selection-progress-user-detail",
    path: "users/:userDisplayId()",
    meta: _91userDisplayId_93exUiAfF6XJr8U6U1fbj66wnLbwrvtJv1PFh19XYP2QQMeta || {},
    component: () => import("/home/circleci/project/pages/selection/progress/users/[userDisplayId].vue")
  }
]
  },
  {
    name: "job-campaigns",
    path: "/job-campaigns",
    meta: indexSPLg2NfbcRRnYaIy_f3TL2JmyU7vr6YvVJZKiei6f08Meta || {},
    component: () => import("/home/circleci/project/pages/job-campaigns/index.vue")
  },
  {
    name: "debug-cascade-select",
    path: "/debug/cascade-select",
    component: () => import("/home/circleci/project/pages/debug/cascade-select.vue")
  },
  {
    name: "debug-messages",
    path: "/debug/messages",
    component: () => import("/home/circleci/project/pages/debug/messages/index.vue")
  },
  {
    name: "GeneratedJobList",
    path: "/generated-jobs",
    meta: indexuXtPK1Lp7K0oJr492rJTuTmQ8_45jytrokwTXR1LlGpLcMeta || {},
    component: () => import("/home/circleci/project/pages/generated-jobs/index.vue")
  },
  {
    name: "job-campaigns-create",
    path: "/job-campaigns/create",
    meta: createF5HkEIBGwMGGfXkYkz_45nirm8ybU0dog7yJZozMa1b80Meta || {},
    component: () => import("/home/circleci/project/pages/job-campaigns/create.vue")
  },
  {
    name: "assist-company-alumni",
    path: "/assist/company-alumni",
    meta: company_45alumnip8qampBnu4vUDbbR5VbfWstXAPs_45Ic4YW78Bp8_Ty9MMeta || {},
    component: () => import("/home/circleci/project/pages/assist/company-alumni.vue"),
    children: [
  {
    name: "assist-company-alumni-user-detail",
    path: ":userDisplayId()",
    meta: _91userDisplayId_93xwLMSahcWIXNKtXs8IsVPrD7__sKUiNVVUWXOKBtjtwMeta || {},
    component: () => import("/home/circleci/project/pages/assist/company-alumni/[userDisplayId].vue")
  }
]
  },
  {
    name: edita6MbPPxBNsSOWq13mLqybX0xHghvjp4t0xZQ65_DRV0Meta?.name,
    path: "/companies/:code()/edit",
    meta: edita6MbPPxBNsSOWq13mLqybX0xHghvjp4t0xZQ65_DRV0Meta || {},
    component: () => import("/home/circleci/project/pages/companies/[code]/edit.vue"),
    children: [
  {
    name: "companies-code-edit",
    path: "",
    meta: indexXhJ68RhzOrz_sC1vKrIwrTGeHEPQYBzXgTnMa9j6N5gMeta || {},
    component: () => import("/home/circleci/project/pages/companies/[code]/edit/index.vue")
  },
  {
    name: "companies-code-edit-addition",
    path: "addition",
    meta: addition_hv8kNAgPWsheUZCYG5kW1xVeIz8QGaf5g7aKD_zhb8Meta || {},
    component: () => import("/home/circleci/project/pages/companies/[code]/edit/addition.vue")
  }
]
  },
  {
    name: "debug-messages-code",
    path: "/debug/messages/:code()",
    component: () => import("/home/circleci/project/pages/debug/messages/[code].vue")
  },
  {
    name: "debug-messages-header",
    path: "/debug/messages/header",
    component: () => import("/home/circleci/project/pages/debug/messages/header.vue")
  },
  {
    name: "profile-update-list-users",
    path: "/updated-users/profile",
    meta: profileTWXNBdvn3AOtszdlNbDVd5HZlSrWt4XXwU34Ac6Q69cMeta || {},
    component: () => import("/home/circleci/project/pages/updated-users/profile.vue"),
    children: [
  {
    name: "profile-updated-user-detail",
    path: ":userDisplayId()",
    meta: _91userDisplayId_93OFvLxingxWSApsjBNOmI_45DEI0Y_45HCC9K0p3UpaaQYeMMeta || {},
    component: () => import("/home/circleci/project/pages/updated-users/profile/[userDisplayId].vue")
  }
]
  },
  {
    name: "companies-code",
    path: "/companies/:code()",
    meta: indexPP2ou8oy0t7gTPimzm2ZAo5FgXhVwB7LpCzayRy2jKkMeta || {},
    component: () => import("/home/circleci/project/pages/companies/[code]/index.vue")
  },
  {
    name: "company-accounts",
    path: "/company-accounts",
    meta: indexNW2EJG1motPFljkecj3RYh5lTYD8ZRD_45pf7jx_45LXNT4Meta || {},
    component: () => import("/home/circleci/project/pages/company-accounts/index.vue")
  },
  {
    name: "JobEdit",
    path: "/jobs/:code()/edit",
    meta: indexDOCM_dL_458iAR41aLbBgW12eY9VHZ8jJBeSonBEmgbx8Meta || {},
    component: () => import("/home/circleci/project/pages/jobs/[code]/edit/index.vue")
  },
  {
    name: _91listCode_9399aryceEe2Gcp_nQf1FYeMj_D_2HTmtUV8wFytT2ggkMeta?.name,
    path: "/talent-pool/:listCode()",
    meta: _91listCode_9399aryceEe2Gcp_nQf1FYeMj_D_2HTmtUV8wFytT2ggkMeta || {},
    component: () => import("/home/circleci/project/pages/talent-pool/[listCode].vue"),
    children: [
  {
    name: "talent-pool-listCode",
    path: "",
    meta: indexJyLgYE9Bj56aVmPv73K8_45SomFJvKqLoKjIPfOc18E2MMeta || {},
    component: () => import("/home/circleci/project/pages/talent-pool/[listCode]/index.vue")
  },
  {
    name: "talent-pool-list-user-detail",
    path: "users/:userDisplayId()",
    meta: _91userDisplayId_93WDjlJmF_45SG8xJzoYzJOTrGo4TxVxCRbFQC_dJec1eYoMeta || {},
    component: () => import("/home/circleci/project/pages/talent-pool/[listCode]/users/[userDisplayId].vue")
  }
]
  },
  {
    name: "intention-update-list-users",
    path: "/updated-users/intention",
    meta: intention1c_xL3xcRuVBhp_45vo7mr1asPmoJIWmygEx_45zuvaLlUEMeta || {},
    component: () => import("/home/circleci/project/pages/updated-users/intention.vue"),
    children: [
  {
    name: "intention-updated-user-detail",
    path: ":userDisplayId()",
    meta: _91userDisplayId_93nD8K3MJxm6iaah4twXsQIzI13IOIW_45pbcnnlfx22S3oMeta || {},
    component: () => import("/home/circleci/project/pages/updated-users/intention/[userDisplayId].vue")
  }
]
  },
  {
    name: "JobEditPreview",
    path: "/jobs/:code()/edit/preview",
    meta: previewGoJnhi26CW0Yvi9uGIppL9WxkTRiC2dLNW4JJRK_SroMeta || {},
    component: () => import("/home/circleci/project/pages/jobs/[code]/edit/preview.vue")
  },
  {
    name: "companies-code-addition",
    path: "/companies/:code()/addition",
    meta: addition8pRFI5mWGIdYgK9tF_1gdje6JtFvtSHBcPrhPowngHgMeta || {},
    component: () => import("/home/circleci/project/pages/companies/[code]/addition.vue")
  },
  {
    name: "job-campaigns-code-edit",
    path: "/job-campaigns/:code()/edit",
    meta: editZj1NNtdLe3DofNmm8w1sXsCdxS9QT8q0dyguRXeyk5MMeta || {},
    component: () => import("/home/circleci/project/pages/job-campaigns/[code]/edit.vue")
  },
  {
    name: "jobs-code-edit-addition",
    path: "/jobs/:code()/edit/addition",
    meta: additiong70SAMnkn_45c1wQU1CM8xCr9yp5u_vdlcxNNiqG_45aewQMeta || {},
    component: () => import("/home/circleci/project/pages/jobs/[code]/edit/addition.vue")
  },
  {
    name: "jobs-code-preview",
    path: "/jobs/:code()/preview",
    meta: indexCyh_45cs2D_RcejN00UaX4EIYKGDFoOUi6rU7t5RP9yRMMeta || {},
    component: () => import("/home/circleci/project/pages/jobs/[code]/preview/index.vue")
  },
  {
    name: "mail-token-type-token",
    path: "/mail-token/:type()/:token()",
    meta: _91token_935LzBOlekUwIP2kl2d9gv9f2SIkk_45md9faczKpG5GHbUMeta || {},
    component: () => import("/home/circleci/project/pages/mail-token/[type]/[token].vue")
  },
  {
    name: "jobs-code-duplicate",
    path: "/jobs/:code()/duplicate",
    meta: indexKJP5ph0Py_45OrsQlRjgvuCFYwMwWLwAijLEJigdryVK4Meta || {},
    component: () => import("/home/circleci/project/pages/jobs/[code]/duplicate/index.vue")
  },
  {
    name: "user-print",
    path: "/users/:userDisplayId()/print",
    meta: printtK7OiSbz3d16jloGmsGjZ2xFk9qyzoMGLJnJc48kLUIMeta || {},
    component: () => import("/home/circleci/project/pages/users/[userDisplayId]/print.vue")
  },
  {
    name: "debug-scout-card-user-detail",
    path: "/debug/scout/card-user-detail",
    component: () => import("/home/circleci/project/pages/debug/scout/card-user-detail.vue")
  },
  {
    name: "design-challenges-2026",
    path: "/design-challenges-2026",
    meta: index0QiQ26fHmL_2_454cbUvoIEEi8_9mcUuapRwvWUX4wnBwMeta || {},
    component: () => import("/home/circleci/project/pages/design-challenges-2026/index.vue")
  },
  {
    name: "GeneratedJobEdit",
    path: "/generated-jobs/:code()/edit",
    meta: indexl9wj4mgJwj7qke9HN2yYotl69hcTwbuXIDPbXmDisMUMeta || {},
    component: () => import("/home/circleci/project/pages/generated-jobs/[code]/edit/index.vue")
  },
  {
    name: "job-introduction-init",
    path: "/job-introduction/:userDisplayId()",
    meta: _91userDisplayId_93Bl4F8Os9fORogGohii0hpheBZguGid1YU3AOPCXcynMMeta || {},
    component: () => import("/home/circleci/project/pages/job-introduction/[userDisplayId].vue")
  },
  {
    name: "GeneratedJobEditPreview",
    path: "/generated-jobs/:code()/edit/preview",
    meta: previewfNlscIXvttguRDPGQlp5keiHFqLxgYhjCaMLjjijsbwMeta || {},
    component: () => import("/home/circleci/project/pages/generated-jobs/[code]/edit/preview.vue")
  },
  {
    name: "GeneratedJobPreview",
    path: "/generated-jobs/:code()/preview",
    meta: index0KCGAh4R_45seJUcWft4lcTg6Vtd2piyRW4kHVHSAhYfkMeta || {},
    component: () => import("/home/circleci/project/pages/generated-jobs/[code]/preview/index.vue")
  },
  {
    name: "design-challenges-2026-assignmentCode-displayId",
    path: "/design-challenges-2026/:assignmentCode()/:displayId()",
    meta: _91displayId_93HGnL9IBN2codlD8phsZzsmj_50j9_45HDdRbgoVlwfxLIMeta || {},
    component: () => import("/home/circleci/project/pages/design-challenges-2026/[assignmentCode]/[displayId].vue")
  }
]